import { createRegisterClientContainer } from './container'
import { RegisterClientUI } from './ui/register-client'

export const RegisterClientPage = createRegisterClientContainer(RegisterClientUI)
